module.exports = __webpack_public_path__ + "img/whatsapp.9d95d756.svg";